import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { IonSlides, ModalController } from '@ionic/angular';
import { Upload } from 'src/app/core/data/schema/upload';
import { ImageViewComponent } from 'src/app/shared/component/image-view/image-view.component';


@Component({
  selector: 'app-content-preview',
  templateUrl: './content-preview.component.html',
  styleUrls: ['./content-preview.component.scss'],
})
export class ContentPreviewComponent implements OnInit {

  @ViewChild('slides', { static: true }) slides: IonSlides;
  @Input() files: Upload[] = [];
  @Input() allowRemove = false;
  @Input() showThumbnails = false;
  @Input() viewHeight: number = 150;
  @Input() thumbSize: number = 70;
  @Input() uploadTitle = "Select a File";
  @Input() uploadDetails;
  @Output() browse: EventEmitter<any> = new EventEmitter();
  @Output() fileRemoved: EventEmitter<Upload> = new EventEmitter();

  @Input() showSlideArrows: boolean = false;
  @Input() showMagnify: boolean = true;
  @Input() thumbnailWrapperMaxWidth: string = 'none';

  activeIndex = 0;
  tsNow: number = 0;
  private currMax = 3;
  private currMin = 0

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
    this.tsNow = new Date().valueOf();
    console.warn("thumbnails", this.files)
  }

  slideChanged(event: any) {
    this.slides.getActiveIndex().then(idx => { this.activeIndex = idx; });
  }

  expandFile(file: Upload) {
    // this.navCtrl.navigateForward('/shared/content/view', { state: { file } });
  }

  next() {
    if (this.activeIndex + 1 < this.files.length) {
      this.setImage(this.activeIndex + 1);
    }
  }

  prev() {
    if (this.activeIndex > 0) {
      this.setImage(this.activeIndex - 1);
    }
  }

  moveSlide(event, slide: string = 'prev') {
    switch (slide) {
      case 'next': this.next(); break;
      default: this.prev(); break;
    }
    event.stopPropagation();
  }

  videoClicked(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  setImage(index: number) {
    this.slides.slideTo(index);
    const dir = (index > this.activeIndex) ? 'left' : 'right';

    this.activeIndex = index;
    
    if (this.showThumbnails) {
      if (dir === 'left' && this.activeIndex > 2) {
        document.getElementById('thumb' + index).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      } else if (dir === 'right' && this.activeIndex < this.files.length) {
        document.getElementById('thumb' + index).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }
  }

  imageAdded() {
    if (this.files.length > 0) {
      this.slides.update().then(() => {
        this.setImage(this.files.length - 1);
      });
    }
  }

  removeImage(file: Upload) {
    const idOf = this.files.indexOf(file);
    this.files.splice(idOf, 1);
    if (idOf < this.files.length) {
      this.activeIndex = idOf;
    } else if (this.files.length > 0) {
      this.activeIndex = this.files.length - 1;
    } else {
      this.activeIndex = 0;
    }
    this.fileRemoved.emit(file);
  }

  async openImagePreview() {
    const modal = await this.modalCtrl.create({
      component: ImageViewComponent,
      swipeToClose: true,
      componentProps: {
        images: this.files.filter(m => m.isImage === true).map(f => f.safeUrl),
        index: this.activeIndex
      },
    });
    await modal.present();
  }

}
